var React = require('react');

function CheckSquare (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.5","y":"0.5","width":"15","height":"15","rx":"1.5","fill":"#2D2927","stroke":"#2D2927","key":0}),React.createElement("path",{"d":"M4 8.698L6.96075 11.1771L13 5","fill":"#2D2927","key":1}),React.createElement("path",{"d":"M4 8.698L6.96075 11.1771L13 5","stroke":"white","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

CheckSquare.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CheckSquare;

CheckSquare.default = CheckSquare;
